import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import axios from 'axios';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';



class ListaPropostasPJ extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: '',
      apiPage: null,
      
      data: [],
      isLoading: true,
      isError: false,
      
      showTable: false,
      showColBroker: false,
      showColSalesman: false,
      showColStage: false,

      currentPage: 0,
      itemsPerPage: 10,
      totalItems: 0,
      
      loadingTable: null,
      searchTerm: '',
      searchField: 'companyName',
      isSearching: false,
    };
    
    this.handleSearch = this.handleSearch.bind(this);
    this.searchTimeout = null;
    this._isMounted = false;
    this.searchInputRef = React.createRef();

    this.errorField = {};

    this.errorFormat = {};

    this.styles = {
      theadTr: { textTransform: "uppercase" },
      inputSearch: { marginLeft: 8, flex: 1 },
      theadTh: { height: 40 },
      tdDate: {
        color: 'rgb(117, 117, 117)',
        margin: 0,
        fontSize: 11,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        lineHeight: '13px',
        letterSpacing: '0.33px',
        textTransform: 'uppercase',
        padding: 0,
        height: 40,
      }
    }

  }

  componentWillUnmount() {
    // Limpa o timeout de busca
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    // Flag para evitar atualizações de estado após desmontagem
    this._isMounted = false;
  }

  handleSearch = (e) => {
    let searchValue = e && e.target ? e.target.value : '';
    const cursorPosition = e.target.selectionStart;
    
    this.setState({
      searchTerm: searchValue,
      currentPage: 0,
      isSearching: true
    }, () => {
      if (this.searchInputRef.current) {
        const input = this.searchInputRef.current.querySelector('input') || this.searchInputRef.current;
        if (input) {
          input.focus();
          if (input.setSelectionRange) {
            input.setSelectionRange(cursorPosition, cursorPosition);
          }
        }
      }
      
      // Limpa o timeout anterior se existir
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      // Aguarda 500ms antes de fazer a busca
      this.searchTimeout = setTimeout(() => {
        this.getData(true);
      }, 500);
    });
  }


  componentDidMount() {
    this._isMounted = true;
    
    let userType = localStorage.getItem('planos_y');
    let state = this.state;

    // Verifica se exibe ou não a coluna 'Corretora'
    /* if (userType !== 'SALESMAN' && userType !== 'BROKER')
      state.showColBroker = true;
    else
      state.showColBroker = false; */

    // Verifica se exibe ou não a coluna 'Vendedor'
    if (userType === 'SALESMAN')
      state.showColSalesman = false;
    else
      state.showColSalesman = true;

    this.setState(state);

    this.getFilterName();
    this.getData(true);
  }

  getFilterName() {
    // pega o filtro para saber q nome exibir no titulo
    let state = this.state;
    let page = this.props.history.location.pathname;

    page = page.split('/');
    page = page[page.length - 1];

    state.page = page;

    if (page === "geralpj") {
      state.titlePage = "TODAS AS PROPOSTAS - PJ";
      state.apiPage = 'all';
    }
    else if (page === "pendentespj") {
      state.titlePage = configBase.statusPendente;
      state.apiPage = 'pjawaitingpayment';
    }
    else if (page === "confpendentespj") {
      state.titlePage = configBase.statusConfPendentePJ;
      state.apiPage = 'pjconfirmation';
    }
    else if (page === "emprocessamentopj") {
      state.titlePage = configBase.statusEmProcessamentoPJ;
      state.apiPage = 'pjprocessing';
    }
    else if (page === "indeferidaspj") {
      state.titlePage = configBase.statusIndeferidaPJ;
      state.apiPage = 'pjpending';
    }
    else if (page === "emanalisepj") {
      state.titlePage = configBase.statusEmAnalisePJ;
      state.apiPage = 'pjinvalidation';
    }
    else if (page === "implantadaspj") {
      state.titlePage = configBase.statusImplementadasPJ;
      state.apiPage = 'pjdeployed60days';
    }
    else if (page === "canceladaspj") {
      state.titlePage = configBase.statusCanceladasPJ;
      state.apiPage = 'pjcanceled60days';
    }
    else
      state.titlePage = "PÁGINA INCORRETA";


    this.setState(state);
  }

  getData(table = false) {
    if (!this._isMounted) return;
    
    let typeBox = this.state.apiPage;
    let url = configBase.api + 'Sales/dataDashboardFilter?access_token=' + localStorage.getItem('planos_t');
    
    let dataPost = {
      userId: localStorage.getItem('planos_u'),
      limit: this.state.itemsPerPage,
      skip: this.state.currentPage * this.state.itemsPerPage,
      type: 'PJ',
    };

    // Adiciona o content ao filtro se não for 'all'
    if (typeBox !== null && typeBox.length > 0 && typeBox !== 'all') {
      dataPost.content = typeBox;
    }

    // Se houver um termo de busca, adiciona ao filtro
    if (this.state.searchTerm) {
      switch (this.state.searchField) {
        case 'companyName':
          dataPost.companyName = String(this.state.searchTerm);
          break;
        case 'cnpj':
          // Remove formatação do CNPJ
          dataPost.cnpj = this.state.searchTerm.replace(/\D/g, '');
          break;
        case 'salesmanName':
          dataPost.salesmanName = String(this.state.searchTerm);
          break;
        case 'proposalNumber':
          // Garante que proposalNumber seja sempre string
          dataPost.proposalNumber = String(this.state.searchTerm);
          break;
        default:
          dataPost[this.state.searchField] = String(this.state.searchTerm);
      }
    }

    if (typeBox === null) {
      if (!this._isMounted) return;
      this.setState({ data: [], isLoading: false, totalItems: 0 });
    } else {
      this.setState({ isLoading: true, isError: false, isSearching: false });

      axios.post(url, dataPost)
        .then((response) => {
          if (!this._isMounted) return;
          
          let state = this.state;
          state.isError = false;
          state.isLoading = false;
          state.isSearching = false;

          // Verifica o vendedor padrão
          if (response.data.salesmanDefault && response.data.salesmanDefault === true)
            state.showColSalesman = true;

          const data = response.data.plans || response.data.companys || [];
          state.data = data;
          state.totalItems = response.data.count || response.data.total || 0;

          if (data.length > 0) {
            this.setColorStatus(data);
          } else {
            this.setState(state, () => {
              if (this.searchInputRef.current) {
                const input = this.searchInputRef.current.querySelector('input') || this.searchInputRef.current;
                if (input) {
                  setTimeout(() => input.focus(), 0);
                }
              }
            });
          }

          if (table === true && state.showTable === false) {
            state.showTable = true;
          }
          
          this.setState(state, () => {
            if (this.searchInputRef.current) {
              const input = this.searchInputRef.current.querySelector('input') || this.searchInputRef.current;
              if (input) {
                setTimeout(() => input.focus(), 0);
              }
            }
          });
        })
        .catch(() => {
          if (!this._isMounted) return;
          this.setState({
            isError: true,
            isLoading: false,
            isSearching: false,
            data: []
          }, () => {
            if (this.searchInputRef.current) {
              const input = this.searchInputRef.current.querySelector('input') || this.searchInputRef.current;
              if (input) {
                setTimeout(() => input.focus(), 0);
              }
            }
          });
        });
    }

  }

  setColorStatus(companys) {
    let colors = {
      'AGUARDANDO PAGAMENTO': {color: configBase.bgPendentePJ, name: configBase.statusPendentePJ},
      'AGUARDANDO CONFIRMAÇÃO': {color: configBase.bgConfPendentePJ, name: configBase.statusConfPendentePJ},
      'EM PROCESSAMENTO': {color: configBase.bgEmProcessamentoPJ, name: configBase.statusEmProcessamentoPJ},
      'EM VALIDAÇÃO': {color: configBase.bgEmAnalisePJ, name: configBase.statusEmAnalisePJ},
      'PENDENTE': {color: configBase.bgIndeferidaPJ, name: configBase.statusIndeferidaPJ},
      'CANCELADO': {color: configBase.bgCanceladasPJ, name: configBase.statusCanceladasPJ},
      'ATIVO': {color: configBase.bgImplementadasPJ, name: configBase.statusImplementadasPJ},
    };
    let state = this.state;

    for (let i = 0; i < companys.length; i++) {
      if (colors[companys[i].status]) {
        companys[i].color = colors[companys[i].status].color;
        companys[i].status = colors[companys[i].status].name;
      } else {
        companys[i].color = configBase.bgPendentePJ || '#f0f0f0';
        companys[i].status = companys[i].status || 'PENDENTE';
      }
    }

    state.data = companys;
    state.showTable = true;
    state.loadingTable = null;
    this.setState(state, () => {
      if (this.searchInputRef.current) {
        const input = this.searchInputRef.current.querySelector('input') || this.searchInputRef.current;
        if (input) {
          setTimeout(() => input.focus(), 0);
        }
      }
    });
  }

  sendDetails(companyId) {
    if (companyId != null) {
      this.props.history.push(`${process.env.PUBLIC_URL}/resumopj?p=${companyId}`);
    }
  }

  render() {
    return (
      <MainLayout history={this.props.history}>
        <div id="listaPropostas" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              {this.state.titlePage}
            </Typography>
          </Paper>

          <div id="listaPropostaConteudo" className="contentepanel">
          {
          this.state.isLoading ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO PROPOSTAS...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.isError ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar lista de propostas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.data.length === 0 ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="listaPropostaTabela">
              {/* CSS antigo do Datatable pode ser mantido se ajudar no estilo visual, mas não é funcional */}
              <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css" />
              <link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css" />

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} style={{marginBottom: 20, marginTop: 14}}>
                  <Paper elevation={1}>
                    <IconButton style={{padding: '6px 5px'}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <select
                      style={{
                        border: 'none',
                        background: 'transparent',
                        marginRight: '2px',
                        padding: '2px',
                        outline: 'none'
                      }}
                      value={this.state.searchField}
                      onChange={(e) => {
                        this.setState({
                          searchField: e.target.value
                        });
                      }}
                    >
                      <option value="companyName">Empresa</option>
                      <option value="cnpj">CNPJ</option>
                      {this.state.showColSalesman && (
                        <option value="salesmanName">Vendedor</option>
                      )}
                      <option value="proposalNumber">Proposta</option>
                    </select>
                    <InputBase
                      id="mySearchText"
                      ref={this.searchInputRef}
                      style={this.styles.inputSearch}
                      placeholder="Pesquisar"
                      value={this.state.searchTerm || ''}
                      onChange={this.handleSearch}
                      inputProps={{ 'aria-label': 'pesquisar propostas' }}
                      onBlur={(e) => {
                        if (this.state.isSearching) {
                          setTimeout(() => {
                            if (this.searchInputRef.current) {
                              const input = this.searchInputRef.current.querySelector('input') || this.searchInputRef.current;
                              if (input) {
                                input.focus();
                              }
                            }
                          }, 0);
                        }
                      }}
                    />
                  </Paper>
                </Grid>
              </Grid>

              {/* Loading durante pesquisa */}
              {this.state.isSearching && (
                <Grid container spacing={2} style={{marginTop: 10}}>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8} style={{textAlign: 'center', marginTop: 20}}>
                    <LinearProgress />
                    <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                      Pesquisando...
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                </Grid>
              )}

              <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                  <tr style={this.styles.theadTr}>
                    <th style={this.styles.theadTh}>
                      <Typography variant="button" display="block" gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}>
                        Data
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography variant="button" display="block" gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}>
                        Empresa
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography variant="button" display="block" gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}>
                        CNPJ
                      </Typography>
                    </th>
                    { this.state.showColSalesman === true && (
                    <th style={this.styles.theadTh}>
                      <Typography variant="button" display="block" gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}>
                        Vendedor
                      </Typography>
                    </th>
                      )
                    }
                    <th style={this.styles.theadTh}>
                      <Typography variant="button" display="block" gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}>
                        Vidas
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography variant="button" display="block" gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}>
                        Valor
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography variant="button" display="block" gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}>
                        Status
                      </Typography>
                    </th>
                  </tr>
                </thead>

                <tbody>
                {this.state.data.map((item, index) =>
                  <tr
                    id={'row_sales_'+item.salesId}
                    key={index}
                    className="row_table"
                    onClick={this.sendDetails.bind(this, item.id)}
                    style={{cursor:'pointer', height: 40, padding: 0}}
                  >
                    <td style={this.styles.tdDate}>
                      {item.dateFormat || item.date}
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom style={{color: '#757575', margin:0, fontSize: 11}}>
                        {item.fantasyName}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom style={{color: '#757575', margin:0, fontSize: 11}}>
                        {item.cnpj}
                      </Typography>
                    </td>
                    { this.state.showColSalesman === true && (
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom style={{color: '#757575', margin:0, fontSize: 11}}>
                        {item.salesman}
                      </Typography>
                    </td>
                      )
                    }
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom style={{color: '#757575', margin:0, fontSize: 11}}>
                        {item.lives}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom style={{color: '#757575', margin:0, fontSize: 11}}>
                        R$ {item.value}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 40}}>
                      <Typography variant="overline" display="block" gutterBottom style={{color: '#757575', margin:0, fontSize: 11}}>
                        <span style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}>
                          {item.status}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                )}
                </tbody>
              </table>

              <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                  <label htmlFor="itemsPerPage">Linhas por página: </label>
                  <select 
                    value={this.state.itemsPerPage}
                    onChange={(e) => {
                      this.setState({
                        itemsPerPage: parseInt(e.target.value, 10),
                        currentPage: 0,
                        isLoading: true
                      }, () => this.getData(true));
                    }}
                    style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  
                  <span style={{marginLeft: 15}}>
                    {this.state.totalItems === 0 ? 0 : this.state.currentPage * this.state.itemsPerPage + 1}-
                    {this.state.totalItems === 0 ? 0 : Math.min((this.state.currentPage + 1) * this.state.itemsPerPage, this.state.totalItems)}
                  </span>
                  {' '}de{' '}
                  <span>{this.state.totalItems}</span>

                  <button 
                    onClick={() => {
                      if (this.state.currentPage > 0) {
                        this.setState({
                          currentPage: this.state.currentPage - 1,
                          isLoading: true
                        }, () => this.getData(true));
                      }
                    }}
                    disabled={this.state.currentPage === 0}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: this.state.currentPage === 0 ? 'default' : 'pointer',
                      opacity: this.state.currentPage === 0 ? 0.5 : 1,
                      marginLeft: 10
                    }}
                  >
                    <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="Anterior">
                      <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
                    </svg>
                  </button>
                  
                  <button 
                    onClick={() => {
                      if ((this.state.currentPage + 1) * this.state.itemsPerPage < this.state.totalItems) {
                        this.setState({
                          currentPage: this.state.currentPage + 1,
                          isLoading: true
                        }, () => this.getData(true));
                      }
                    }}
                    disabled={(this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      cursor: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 'default' : 'pointer',
                      opacity: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 0.5 : 1
                    }}
                  >
                    <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="Próximo">
                      <path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path>
                    </svg>
                  </button>
                </div>
              </div>

            </div>
              )
              )
            )
          }
          </div>
        </div>
      </MainLayout>
    );
  }

}

ListaPropostasPJ.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasPJ);